import axios from 'axios';
import apiClient from './apiClient';

// ─── Login ────────────────────────────────────────────────────────────────────
export const login = async (email, password) => {
  const response = await fetch('/api/Auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Giriş başarısız.');
  }
  return response.json();
};

// ─── Şifremi unuttum ──────────────────────────────────────────────────────────
export const forgotPassword = async (email) => {
  const response = await fetch('/api/Auth/forgot-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'İstek başarısız.');
  }
  return response.json();
};

// ─── İlk kez giriş — aktivasyon linki talep et ───────────────────────────────
export const activateAccount = async (email) => {
  const response = await fetch('/api/Auth/activate-account', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'İstek başarısız.');
  }
  return response.json();
};

// ─── Şifre sıfırla (token ile) ───────────────────────────────────────────────
export const resetPassword = async (token, newPassword) => {
  const response = await fetch('/api/Auth/reset-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Şifre sıfırlama başarısız.');
  }
  return response.json();
};

// ─── Şifre değiştir (giriş yapmış kullanıcı) ─────────────────────────────────
export const changePassword = async (currentPassword, newPassword) => {
  const response = await apiClient.post('/Auth/change-password', {
    currentPassword,
    newPassword,
  });
  return response.data;
};

// ─── Mevcut kullanıcı bilgisi (httpOnly cookie ile) ──────────────────────────
export const getCurrentUser = () =>
  axios.get('/api/Auth/me', { withCredentials: true }).then((r) => r.data);

// ─── Çıkış (sunucu taraflı cookie temizleme) ─────────────────────────────────
export const logoutUser = async () => {
  await apiClient.post('/Auth/logout');
};
